import React from 'react'
import { Button } from '../ui/button'
import { Badge } from '../ui/badge'
import { IdentityRole } from '../../model/Event'

interface RoleSelectProps {
  roles: IdentityRole[]
  selected: number[]
  onChange: (ids: number[]) => void
  schedulableOnly?: boolean
}

export const RoleSelect: React.FC<RoleSelectProps> = ({ roles, selected, onChange, schedulableOnly }) => {
  const filtered = schedulableOnly ? roles.filter((r) => r.schedulable) : roles
  const sorted = [...filtered].sort((a, b) => a.internalName.localeCompare(b.internalName))

  return (
    <div className="space-y-2">
      <div className="flex gap-1.5">
        <Button variant="outline" size="sm" className="h-7 text-xs" onClick={() => onChange(sorted.map((r) => r.id))}>All</Button>
        {!schedulableOnly && (
          <>
            <Button variant="outline" size="sm" className="h-7 text-xs" onClick={() => onChange(roles.filter((r) => r.schedulable).map((r) => r.id))}>Schedulable</Button>
            <Button variant="outline" size="sm" className="h-7 text-xs" onClick={() => onChange(roles.filter((r) => !r.schedulable).map((r) => r.id))}>Non-Schedulable</Button>
          </>
        )}
        <Button variant="outline" size="sm" className="h-7 text-xs" onClick={() => onChange([])}>Clear</Button>
      </div>
      <div className="flex flex-wrap gap-1.5 p-2 border rounded-md bg-muted/10 min-h-[36px]">
        {sorted.map((role) => {
          const isSelected = selected.includes(role.id)
          return (
            <Badge
              key={role.id}
              variant={isSelected ? 'default' : 'outline'}
              className="text-xs cursor-pointer select-none"
              onClick={() => onChange(isSelected ? selected.filter((id) => id !== role.id) : [...selected, role.id])}
            >
              {role.internalName}
            </Badge>
          )
        })}
        {sorted.length === 0 && <span className="text-xs text-muted-foreground italic">No roles available</span>}
      </div>
    </div>
  )
}
